(function () {
  "use strict";
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.documentElement.classList.add("js-motion");

  var reveals = document.querySelectorAll("[data-reveal]");
  if (reduce || !("IntersectionObserver" in window)) {
    reveals.forEach(function (el) { el.classList.add("is-revealed"); });
  } else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-revealed"); io.unobserve(e.target); } });
    }, { threshold: 0, rootMargin: "0px 0px 300px 0px" });
    reveals.forEach(function (el) {
      if (el.getBoundingClientRect().top < innerHeight) el.classList.add("is-revealed");
      else io.observe(el);
    });
  }

  document.querySelectorAll("img").forEach(function (img) {
    if (img.complete && img.naturalWidth) { img.classList.add("is-loaded"); return; }
    ["load", "error"].forEach(function (ev) {
      img.addEventListener(ev, function () { img.classList.add("is-loaded"); }, { once: true });
    });
  });
})();
